//mdx editor is importing lexical and lexical/code which is using prism, which relies on import order,
//which is not guaranteed in esm. As a workaround import prism core as the very first, so its guaranteed to be defined
import "prismjs";
import React from "react";
import { createRoot } from "react-dom/client";
import { version } from "../../appVersion.json";
import Root from "./Root";
import isDev from "./features/common/utils/isDev";
import "./index.css";
import { initSentry } from "./initSentry";
// On page load or when changing themes, best to add inline in `head` to avoid FOUC

// Call the initSentry function to initialize Sentry - prod only
if (!isDev) {
  initSentry();
}

const themeSetInLocalStorage = localStorage["interface.theme"] ?? null;

try {
  if (!("interface.theme" in localStorage)) {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) {
      document.documentElement.classList.add("dark");
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.classList.add("light");
      document.documentElement.setAttribute("data-theme", "light");
    }
  } else {
    if (JSON.parse(themeSetInLocalStorage) === "dark") {
      document.documentElement.classList.add("dark");
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.classList.add("light");
      document.documentElement.setAttribute("data-theme", "light");
    }
  }
} catch {
  document.documentElement.classList.add("light");
  document.documentElement.setAttribute("data-theme", "light");
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Could not find root element to attach react to");
}

document.title = `ONE RACEHUB ${version}`;
createRoot(rootElement).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);

if (isDev()) {
  // REGISTER ERROR OVERLAY
  const showErrorOverlay = (err: ErrorEvent) => {
    // must be within function call because that's when the element is defined for sure.
    const ErrorOverlay = customElements.get("vite-error-overlay");
    // don't open outside vite environment
    if (!ErrorOverlay) {
      return;
    }
    console.log(err);
    const overlay = new ErrorOverlay(err);
    if (
      err.message === "ResizeObserver loop limit exceeded" ||
      err.message === "ResizeObserver loop completed with undelivered notifications."
    ) {
      return;
    } else {
      document.body.appendChild(overlay);
    }
  };

  window.addEventListener("error", showErrorOverlay);
  window.addEventListener("unhandledrejection", ({ reason }) => showErrorOverlay(reason));
}
